import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { LOGO_URL, WHATSAPP_URL } from '../../data/links';
import { PrimaryLink } from '../ui/PrimaryLink';
import { Reveal } from '../ui/Reveal';
export function Closing() {
  const {
    t
  } = useLanguage();
  return <section id="contacto" className="bg-white py-32 md:py-52" data-id="element-141" data-mp="1cphrwbbgykwu">
      <div className="mx-auto max-w-4xl px-5 text-center" data-id="element-142" data-mp="1cp81wnqfcdr5">
        <Reveal data-id="element-143" data-mp="17qod8fkg4nv3">
          <img src={LOGO_URL} alt="" className="mx-auto mb-10 h-12 w-12 rounded-full" data-id="element-144" data-mp="17r6jm50toigq" />
        </Reveal>
        <Reveal delay={0.04} data-id="element-145" data-mp="12ywmo51aii4y">
          <h2 className="text-5xl font-semibold leading-[1] tracking-[-0.04em] text-graphite md:text-8xl" data-id="element-146" data-mp="12xlkuarenkgh">
            {t.closing.title}
          </h2>
        </Reveal>
        <Reveal delay={0.1} data-id="element-147" data-mp="t2tn96xtoxlp">
          <p className="mx-auto mt-6 max-w-xl text-lg leading-snug text-subtle md:text-2xl" data-id="element-148" data-mp="szfk3whc4kd7">
            {t.closing.text}
          </p>
        </Reveal>
        <Reveal delay={0.16} className="mt-12" data-id="element-149" data-mp="k1vd06wsjtuo">
          <PrimaryLink href={WHATSAPP_URL} external tone="light" data-id="element-150" data-mp="k36hya1z37nd">
            {t.closing.cta}
          </PrimaryLink>
        </Reveal>
      </div>
    </section>;
}